import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatRadioButton, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-all-observation',
  templateUrl: './all-observation.component.html',
  styleUrls: ['./all-observation.component.scss'],
})
export class AllObservationComponent implements OnInit {
  @ViewChild('YesInput', { static: true }) yes: MatRadioButton;
  @ViewChild('NoInput', { static: true }) no: MatRadioButton;
  outvalue: boolean;
  status: string;
  isOpenOnly: boolean;
  constructor(
    private dialogRef: MatDialogRef<AllObservationComponent>,
    @Inject(MAT_DIALOG_DATA) public recievedData: any
  ) {
    this.status = recievedData.status;
    this.isOpenOnly = recievedData.isOpenOnly;
  }

  ngOnInit() {}

  closePopup() {
    this.dialogRef.close();
    return false;
  }

  saveButton() {
    // if (this.yes.checked) {
    this.outvalue = true;
    // }
    // else {
    //   this.outvalue = false;
    // }
    this.dialogRef.close({ event: this.outvalue });
    //this.closePopup();
  }

  close() {
    this.outvalue = false;
    this.dialogRef.close({ event: this.outvalue });
    // this.closePopup();
  }
}
